import React, {Fragment} from 'react';

import TabbedBasePage from "../Base/ReactTabbedBasePage";
import PEPFeedbackSummarySW from "./ReactPEPFeedbackSummarySW";
import PEPSocialWorkerNotesForm from "./PEPSocialWorkerNotesForm";
import PEPFeedbackConfirm from "./ReactPEPFeedbackConfirm";
import {checkError} from 'root/DataFunctions/BaseDataFns'

export default class TabbedWorkflowSocialWorkerFeedback extends TabbedBasePage
{
	constructor(props)
	{
		super(props);
		
		this.keyCount = 0 ;

		this.state.mode = 'edit';
		this.state.loading = true ;
		this.state.displayModal= false;
		this.state.pep_id = props.pep_id;
		this.state.esw_id = null ;
		this.state.child_forename  = null ;
		this.state.child_surname  = null ;
		this.state.activePage  = 'summary' ;
		this.state.displayErrors  = false ;
		this.state.tabItems = 					
		{ 
			activePanel: 'summary', 
			items:
			[ 
				{id: 'summary',  prev: null, next: 'feedback', title: 'Welcome', enabled: true},
				{id: 'feedback',  prev: 'summary', next: 'confirmation', title: 'Notes', enabled: true},
				{id: 'confirmation',  prev: 'feedback', next: null, title: 'Confirmation', enabled: false}
			] 
		} 
	}
	
	getTabItemsForPEPgroup( yearGroupId )
	{
		switch ( +yearGroupId )
		{
			case 1:

				var tabItems = 					
				{ 
					activePanel: 'summary', 
					items:
					[
                        {id: 'summary',  prev: null, next: 'feedback', title: 'Welcome', enabled: true},
                        {id: 'feedback',  prev: 'summary', next: 'confirmation', title: 'Notes', enabled: true},
                        {id: 'confirmation',  prev: 'feedback', next: null, title: 'Confirmation', enabled: false}
					] 
				} ;

				break ;

			case 4:

				var tabItems = 					
				{ 
					activePanel: 'summary', 
					items:
					[
                        {id: 'summary',  prev: null, next: 'feedback', title: 'Welcome', enabled: true},
                        {id: 'feedback',  prev: 'summary', next: 'confirmation', title: 'Notes', enabled: true},
                        {id: 'confirmation',  prev: 'feedback', next: null, title: 'Confirmation', enabled: false}
					] 
				} ;

				break ;

			default:

				var tabItems = 					
				{ 
					activePanel: 'summary', 
					items:
					[
                        {id: 'summary',  prev: null, next: 'feedback', title: 'Welcome', enabled: true},
                        {id: 'feedback',  prev: 'summary', next: 'confirmation', title: 'Notes', enabled: true},
                        {id: 'confirmation',  prev: 'feedback', next: null, title: 'Confirmation', enabled: false}
					] 
				} ;

				break ;
		}

		return tabItems  ;
	}

	getFormData ()
	{
		
		var data = {} ;

		data.pep_id = this.state.pep_id ;
		
		// Get all of the combined data from the child form
		//data.foundation_progress_data  = this.refs.progress.getFormData() ;

		//data.attendance_data = this.refs.attendance.getFormData() ;
		
		data.feedback_data = this.refs.feedback.getFormData() ;

		//data.childview_data = this.refs.childviews.getFormData() ;
		
		return data ;
		
	}
	
	lastFormAction()
	{
		var ok = true ;
		if ( this.refs.curriculum != null )
		{
			if ( !this.refs.curriculum.formIsValid())
			{
				ok = false ;
				this.setErrorTab ( 'progress') ;
			}
			else
			{
				this.refs.curriculum.autoSave() ;
			}	
		}

		if ( this.refs.progress != null )
		{
			if ( !this.refs.progress.formIsValid())
			{
				ok = false ;
				this.setErrorTab ( 'progress') ;
			}
			else
			{
				this.refs.progress.autoSave() ;
			}	
		}

		if ( ok && this.refs.attendance != null )
		{
			if ( ok && !this.refs.attendance.formIsValid())
			{	
				ok = false;
				this.setErrorTab ( 'attendance') ;
			}
			else
			{
				this.refs.attendance.autoSave() ;
			}
		}
		
		if ( ok && this.refs.feedback != null )
		{
			if ( ok && !this.refs.feedback.formIsValid())
			{	
				this.setErrorTab ( 'feedback') ;
			}
			else
			{
				this.refs.feedback.autoSave() ;
			}
		}
		
		if ( ok && this.refs.general != null )
		{
			if ( ok && !this.refs.general.formIsValid())
			{	
				this.setErrorTab ( 'general') ;
			}
			else
			{
				this.refs.general.autoSave() ;
			}
		}
		
		if ( ok && this.refs.childviews != null )
		{
			if ( ok && !this.refs.childviews.formIsValid())
			{	
				this.setErrorTab ( 'childviews') ;
			}
			else
			{
				this.refs.childviews.autoSave() ;
			}
		}
		
		if ( ok && this.refs.achievement != null )
		{
			if ( ok && !this.refs.achievement.formIsValid())
			{	
				this.setErrorTab ( 'achievement') ;
			}
			else
			{
				this.refs.achievement.autoSave() ;
			}
		}
		
		this.performSubmit() ;

	}
	
	UNSAFE_componentWillMount()
	{
		if ( this.props.workitem_id != null )
		{
			this.getWorkitemData ( this.props.workitem_id ) ;
		}

		if ( this.props.pep_id != null )
		{
			this.getDataUsingPepId ( this.props.pep_id ) ;
		}

	}

	UNSAFE_componentWillReceiveProps(nextProps)
	{
		if ( nextProps.value != this.props.value )
		{
			var isValid = this.isValueValid(nextProps.value) ;
		
			// Set our initial validity state
			this.setState ( { val: nextProps.value, valid: isValid }) ;
		}
	}

	ajaxError ( data )
	{
		var url = atob(this.props.return_url) ;

		bootbox.alert({ 
		  size: "large",
		  title: "Operation completed",
		  message: "The request has been approved. Click OK to return.", 
		  callback: function()
		  { 
	          location.assign(url);
		  }
		})		
	}

	getDataUsingPepId( pep_id )
	{
		// Globals are defined in the globals.js class
		var root = Globals.APIFolder ;
		
    	$.ajax({
    		  type: 'GET',
    		  url: root + '/peps/'+pep_id,
    		  data: {},
    		  beforeSend:function(){
    		    // this is where we append a loading image
    		  },
    		  success:(data)=>{
    			  
      			var status = data.status ;
      			var records = data.data ;

    			if ( status.result == 'success')
    			{
    				if ( status.rowsAffected == 1)
    				{
    					var pepRec = records[0] ;

						var groupId = pepRec.pep_year_group ;
    					
    					// The data elements include questions etc so we need the whole data array
						this.setState ( { loading: false, pep: pepRec, tabItems: this.getTabItemsForPEPgroup( groupId )}) ;
    				}
    			}
    			else
    			{
    				var displayMessage = "<p>Error File: " + status.errorDetail.file + '</p>';
    				displayMessage += "<p>Error Line: " + status.errorDetail.line + '</p>' ;
    				displayMessage += '<p>' + status.errorDetail.message + '/p' ;

					bootbox.alert({ 
					  size: "large",
					  title: "The operation failed",
					  message: displayMessage, 
					  callback: function()
					  { 
					  }
					})    				
				}  				

    		  },
    		  error:(jqXHR, textStatus, error)=>{

					bootbox.alert({ 
					  size: "large",
					  title: "The operation failed",
					  message: error.stack + '\n' + jqXHR.responseText + '<br><br>' + getErrorObject().stack, 
					  callback: function()
					  { 
					  }
					})	    		  	
  		  		}
    		});
	}
	
	// This function creates the review record structure from the child's template and returns the data
	// created ready to e displayed on the forms
	performSubmit ( formdata ) 
	{
		// Globals are defined in the globals.js class
		var root = Globals.APIFolder ;
		
		var data = { } ; 
		
		var url = root + '/peps/' + this.state.pep_id + '/socialworkerfeedback'   ;
		
    	$.ajax({
  		  type: 'PUT',
  		  url: url,
  		  data: data,
  		  async: false,
  		  success:(data)=>{
  			  
  				// Call the whole thing off	

  				if ( checkError(data))
  				{
					this.setState ( 
					{ 
						mode: 'completed'
					});  					
  				}	

  		  },
  		  error:function(jqXHR, textStatus, error){
  		    // failed request; give feedback to user

			handleAjaxError(jqXHR, textStatus, error);
  		  }
  		});


	}

	
	getWorkitemData( workitemid )
	{
		// Globals are defined in the globals.js class
		var root = Globals.APIFolder ;
		
    	$.ajax({
    		  type: 'GET',
    		  url: root + '/workitems/'+workitemid,
    		  data: { },
    		  beforeSend:function(){
    		    // this is where we append a loading image
    		  },
    		  success:(data)=>{

				var status = data.status ;
				var record = data.data ;

    		  	if ( this.props.return_url != null )
    		  	{
	      			var returnurl = atob(this.props.return_url) ;		  		
    		  	}
  
      			if ( status.result != 'success' )
  				{
      				ajaxError ( data ) ;
  				}
      			else
  				{
      				var esw_id = record[0].work_item_owner_user_id ;
      				
					var workitemData = data.metadata ;

					var child_surname = workitemData.child_surname ;
					var child_forename = workitemData.child_forename ;  				
					var pep1_document = workitemData.pep1_path ;  				

					// Trigger a re-render with the child data
					this.setState ( { esw_id: esw_id, child_forename: child_forename, child_surname: child_surname }) ;
  				}
    		  },
    		  error:(jqXHR, textStatus, error)=>{
			        handleAjaxError(jqXHR, textStatus, error);
		  		}

    		});
	}
	
	
	tabContent ( id )
	{
		switch ( id )
		{
			case 'summary':
				return React.createElement(PEPFeedbackSummarySW, {
					key: this.keyCount++, 
					child_forename: this.state.child_forename, 
					child_surname: this.state.child_surname,
					pep_id: this.state.pep_id,
					id: 'SummaryForm', 
					ref: 'summary', 
					prevButtonRequired: this.shouldPrevButtonShow( id ), 
					nextButtonRequired: this.shouldNextButtonShow( id ),  
					mode: 'edit',
                    showButtons: false,
					navigationNotifier: this.onNavigate.bind(this)
					}, null)
				break ;

			case 'feedback':

				if ( this.state.pep != null )
				{
					var year_id = this.state.pep.year_id ; 
				}
				else
				{
					var year_id = 0 ; 
				}

				return React.createElement(PEPSocialWorkerNotesForm, {
					key: this.keyCount++, 
					pep_id: this.state.pep_id,
					year_id: year_id,
					suppressReminderButton: true,
					id: 'NotesForm', 
					ref: 'feedback', 
					prevButtonRequired: this.shouldPrevButtonShow( id ), 
					nextButtonRequired: this.shouldNextButtonShow( id ),  
					mode: 'edit', 
					displayErrors: this.state.displayErrors,
					showButtons: false,
					navigationNotifier: this.onNavigate.bind(this),
					autoSave: true
					}, null)
				break ;
			
			case 'confirmation':
				return React.createElement(PEPFeedbackConfirm, {  
					key: this.keyCount++, 
					pep_id: this.state.pep_id,
					id: 'ConfirmationForm', 
					ref: 'confirmation', 
					prevButtonRequired: this.shouldPrevButtonShow( id ), 
					nextButtonRequired: this.shouldNextButtonShow( id ),  
					onSave: this.lastFormAction.bind(this),
					mode: 'edit', 
					displayErrors: this.state.displayErrors,
					navigationNotifier: this.onNavigate.bind(this),
					autoSave: true
					}, null)

			default:
				return React.createElement('h1', {  key: this.keyCount++ }, 'Content for Page ' + id) ;			
		}
	}
	
	getMenuItems()
	{
		return this.state.tabItems ;
	}

	renderedComponent()
	{
    	return React.createElement ('div', {  key: this.keyCount++, className: 'input-group' }, this.tabbedHeaders('nav-tabs'));
		
	}

	completePanelBody()
	{
		return (
			<Fragment>
				<div className='panel-body'>
					<h3>That's it!</h3>
					<h4>Thank you for submitting your PEP feedback.</h4>
					<h5>If this feedback relates to a forthcoming PEP meeting, you will be contacted in due course.</h5>
					<h5>In the meantime, if you have any queries regarding this process, please contact the Education Support Worker who sent this invite.</h5>
					<h5>Please close this browser window now.</h5>
				</div>
			</Fragment>
		)
	}

	displayComplete() 
	{
		var lineList = [] ;
		
		lineList.push ( React.createElement ( 'div', { key: this.keyCount++, className: 'panel-heading'}, "Feedback submitted successfully")) ;
		lineList.push ( this.completePanelBody()) ;		
		
		return React.createElement ( 'div', { className: 'panel panel-success'}, lineList)
	}
	
    render() 
    {
    	this.keyCount = 0 ;

		if ( this.state.loading == true )
    	{
	        return React.createElement('div', { key: this.keyCount++, className: ''}, "LOADING...");		    		
    	}
		else
		{
	    	if ( this.state.mode == 'completed' )
	    	{
	    		return this.displayComplete()
	    	}
	    	else
			{
	        	if ( this.state.displayModal )
	        	{
	        		return this.displayModalDialog() ;
	        	}
	        	else
	    		{
	            	return this.renderedComponent() ;    			
	    		}    			
			}	
		}
    }
};


